<div class="filter-container" style="display: flex; gap: 1rem">
  <mat-form-field appearance="outline">
    <mat-label>{{ 'Kërko lajmin' | translate }}</mat-label>
    <input (keyup.enter)="applyFilter()" [(ngModel)]="filterTitle" matInput>
  </mat-form-field>

  <button color="primary" mat-raised-button (click)="applyFilter()"
          style="height: 55px">{{ 'Apply Filter' | translate }}
  </button>

  <button color="secondary" mat-raised-button (click)="clearFilter()"
          style="height: 55px">{{ 'Clear' | translate }}
  </button>

  <button color="primary" mat-raised-button (click)="addNews()"
          style="height: 55px; margin-left: auto">{{ 'Create News' | translate }}
  </button>
</div>

<table mat-table [dataSource]="news" class="mat-elevation-z8">
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef> {{ 'Titulli' | translate }}</th>
    <td mat-cell *matCellDef="let aNew">{{ aNew.alTitle | truncate:50 }}</td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th *matHeaderCellDef mat-header-cell> {{ 'Statusi' | translate }}</th>
    <td *matCellDef="let aNew" mat-cell>{{ aNew.status | truncate:100 }}</td>
  </ng-container>

  <ng-container matColumnDef="open">
    <th mat-header-cell *matHeaderCellDef> {{ 'Edit' | translate }} </th>
    <td mat-cell *matCellDef="let aNew">
      <a [routerLink]="['/editor-panel/editor-news', aNew.id]" style="cursor: pointer; color: deepskyblue; font-size: 18px; margin-left: 1rem">
        <i class="fa fa-edit"></i>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="remove">
    <th mat-header-cell *matHeaderCellDef> {{ 'Remove' | translate }} </th>
    <td mat-cell *matCellDef="let aNew">
      <a (click)="deleteNews(aNew.id)" style="cursor: pointer; color: red; font-size: 18px; margin-left: 1rem;">
        <i class="fa fa-remove"></i>
      </a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>

<mat-paginator [pageSize]="pageSize" [length]="totalItems" (page)="onPageChange($event)"></mat-paginator>
